import { ReducerState } from "reducers";

export const isCtrlKeyLoaded = (state: ReducerState, ctrlKey: string): boolean => {
  const index = state.adminDatatable.ctrlKeys.findIndex(
    ctrlKeyAndUsage => ctrlKeyAndUsage.ctrlKey === ctrlKey
  );
  return index > -1;
};
